var Plugin = require("common/Plugin");
var AboutController = require("about/AboutController");
var AboutView = require("./AboutView");
var DefaultLogger = require("common/DefaultLogger");
var Config = require("settings/Configuration");

function AboutPlugin() {
    var self = this;

    function start() {
        var logger = new DefaultLogger(Config.get("loglevel"));
        var aboutView = new AboutView();

        var aboutController = new AboutController(logger, aboutView);

        self.registerController(aboutController);

        ["addOptionsMenuEntry", "addPreAuthMenuEntry"].forEach(function(fn) {
            self[fn]($.t("common::about.title"),
                aboutController.showAboutView,
                10);
        });
    }

    return {start : start};
}

AboutPlugin.prototype = Plugin;

module.exports = AboutPlugin;


//////////////////
// WEBPACK FOOTER
// ./about/AboutPlugin.js
// module id = 58
// module chunks = 0 3